import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 21,
    type: CHECKLIST_ITEM_TYPE.UPLOAD_DOCUMENT,
    manifestKey: 'UPLOAD_DOCUMENT',

    try_it: {
        button_label: 'Upload Document',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'UploadDocumentCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { lead_media_id: 9999 },
        },
    },
    pre_flight_diff: [
        'Step 1: POST /leads/{lead_pk}/leads-media/ multipart — creates LeadMedia record',
        'Step 2: POST /checklist/{iid}/complete/ with lead_media_id — checklist item: PENDING → YES',
        'LeadMedia.lead_treatment_id updated to task\'s bound treatment (if any)',
        '⚠ Drift risk: if LeadMedia created but complete POST fails, LeadMedia is orphaned (no treatment link, not recorded in checklist)',
        'Multi-tenant safety: LeadMedia scoped to lead+practice before update',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
